import React from 'react';
import { Star } from './star';
import { toFixed, range } from './utils';
import styles from './style.module.scss';

interface RatingProps {
  rating: number;
  count: number;
}

export const Rating = ({ rating, count }: RatingProps) => (
  <div className={styles.rating}>
    <div className={styles.stars}>
      <span className={styles['one-star']}>
        <Star className={styles.star} />
      </span>
      <span className={styles['other-stars']}>
        {range(4).map((i) => (
          <Star className={styles.star} key={i} />
        ))}
      </span>
    </div>
    {toFixed(rating, 1)}
    <span className={styles['rating-count']}>({count})</span>
  </div>
);
